import ReactDom from "react-dom";
import AlertBase from "@/components/CRMAlert/AlertBase";
import Star from "@/assets/star.svg";
import Hammer from "@/assets/hammer.svg";
import styles from "./index.module.css";

const getDefaultKey = () => Math.random().toString(36).substr(2);

const nodes = {};

const container = document.body;

const unmount = (key) => {
  const node = nodes[key];
  ReactDom.unmountComponentAtNode(node);
  container.removeChild(node);
  delete nodes[key];
};

const close = (key) => {
  if (key) return unmount(key);
  Object.keys(nodes).forEach(unmount);
};

const CRMAlertFactory = (params) => {
  const { duration } = params;
  const key = getDefaultKey();
  const node = document.createElement("div");
  nodes[key] = node;
  container.appendChild(node);
  ReactDom.render(
    <AlertBase key={key} {...params} onClose={() => close(key)} />,
    node
  );
  const timer = setTimeout(() => {
    if (nodes[key]) {
      unmount(key);
    }
    clearTimeout(timer);
  }, duration);
};

const renderContentDiv = (content, type, isFullWidth) => {
  return (
    <div className={styles.contentDiv}>
      <img
        src={type === "star" ? Star : Hammer}
        alt={type}
        className={styles.img}
      />
      <div style={{ fontSize: isFullWidth ? 18 : 16 }}>{content}</div>
    </div>
  );
};

const CRMAlert = {
  success({
    content = "Congratulations! You are now a member. You'll receive a message from us with a link to track your reward points.",
    duration = 10000,
    isFullWidth = false,
  }) {
    const params = {
      content: renderContentDiv(content, "star", isFullWidth),
      duration,
      isFullWidth,
    };
    CRMAlertFactory(params);
  },
  error({
    content = "We are unable to process your membership right now. Please ask a server for assistant. Rest assured, You are on the Waitlist!",
    duration = 10000,
    isFullWidth = false,
  }) {
    const params = {
      content: renderContentDiv(content, "hammer", isFullWidth),
      duration,
      isFullWidth,
    };
    CRMAlertFactory(params);
  },
};

export default CRMAlert;
